import { CheckCircle } from '@mui/icons-material'
import { Box, CardContent, CardMedia, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import { demoProfilePicture } from '../../utils/Constants'

const ChannelCard = ({ channelDetail,marginTop }) => {
    console.log(channelDetail)
    return (
        <div className="text-white ">
            <Box sx={{ borderRadius: "50%", display:"flex",width:{xs:"356px",md:"320px"},height:"326px" ,justifyContent:"center",alignItems:"center",zIndex:10 , marginTop:marginTop}}>
                <Link to={`/channel/${channelDetail?.id?.channelId} `}>
                    <CardContent className="">
                        <CardMedia image={channelDetail?.snippet?.thumbnails?.medium?.url || demoProfilePicture} alt={channelDetail?.snippet?.title} sx={{ width: "180px", height: "180px", borderRadius: "50%",mb:"15px" }} />
                        <Typography className='flex items-center justify-center text-slate-600'>
                            {channelDetail?.snippet?.title} <CheckCircle fontSize='12' className="ml-2"/>
                        </Typography>
                        {
                            channelDetail?.statistics?.subscriberCount && (
                                <Typography className='text-red-600'>{parseInt(channelDetail?.statistics?.subscriberCount).toLocaleString("en-US")} Subscribers</Typography>
                            )
                        }
                    </CardContent>
                </Link>
            </Box>
        </div>
    )
}

export default ChannelCard
